import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteContentContext = createContext({
  content: {},
  editMode: false,
  setEditMode: () => {},
  isAdmin: false,
  updateContent: async () => {},
  resetContent: async () => {},
});

export const useSiteContent = () => useContext(SiteContentContext);

export function SiteContentProvider({ isAdmin = false, children }) {
  const [content, setContent] = useState({});
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    axios.get(`${API}/site-content`).then(r => setContent(r.data || {})).catch((e) => console.warn('Failed to load site content', e));
  }, []);

  // Force edit mode off for non-admins
  useEffect(() => {
    if (!isAdmin) setEditMode(false);
  }, [isAdmin]);

  const updateContent = useCallback(async (key, value) => {
    let previous;
    setContent(prev => { previous = prev[key]; return { ...prev, [key]: value }; });  // optimistic
    try {
      await axios.put(`${API}/admin/site-content/${key}`, { value }, { withCredentials: true });
    } catch (e) {
      setContent(prev => {
        const next = { ...prev };
        if (previous === undefined) delete next[key];
        else next[key] = previous;
        return next;
      });
      throw e;
    }
  }, []);

  const resetContent = useCallback(async (key) => {
    setContent(prev => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
    await axios.delete(`${API}/admin/site-content/${key}`, { withCredentials: true });
  }, []);

  return (
    <SiteContentContext.Provider value={{ content, editMode, setEditMode, isAdmin, updateContent, resetContent }}>
      {children}
    </SiteContentContext.Provider>
  );
}
